var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    width: 20,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 14q-.312 0-.531-.219Q3 13.562 3 13.25q0-.312.219-.531.219-.219.531-.219.312 0 .531.219.219.219.219.531 0 .312-.219.531Q4.062 14 3.75 14Zm0-3.25q-.312 0-.531-.219Q3 10.312 3 10q0-.312.219-.531.219-.219.531-.219.312 0 .531.219.219.219.219.531 0 .312-.219.531-.219.219-.531.219Zm0-3.25q-.312 0-.531-.219Q3 7.062 3 6.75q0-.312.219-.531Q3.438 6 3.75 6q.312 0 .531.219.219.219.219.531 0 .312-.219.531-.219.219-.531.219ZM6 14v-1.5h11V14Zm0-3.25v-1.5h11v1.5ZM6 7.5V6h11v1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.fe86a880.svg";
export { ForwardRef as ReactComponent };